import { api } from '../index';

const prefix = '/api/boxing/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectInvoice(param) {
	return api.post(prefix + 'selectInvoice', param);
}

export function apiSelectBoxInformation(param) {
	return api.post(prefix + 'selectBoxInformation', param);
}

export function apiInsertBox(param) {
	return api.post(prefix + 'insertBox', param);
}

export function apiDeleteBox(param) {
	return api.post(prefix + 'deleteBox', param);
}

export function apiDeleteBoxBatch(param) {
	return api.post(prefix + 'deleteBoxBatch', param);
}

export function apiAdjustBox(param) {
	return api.post(prefix + 'adjustBox', param);
}

export function apiSelectBoxItemList(param) {
	return api.post(prefix + 'selectBoxItemList', param);
}

export function apiUpdateBoxItemList(param) {
	return api.post(prefix + 'updateBoxItemList', param);
}

export function apiClearBoxInformation(param) {
	return api.post(prefix + 'clearBoxInformation', param);
}

export function apiSelectInvoiceItemList(invoice_no, for_boxing) {
	return api.get(prefix + 'selectInvoiceItemList', { params: { invoice_no, for_boxing } });
}

export function apiSelectWarehouseMemoList(param) {
	return api.post(prefix + 'selectWarehouseMemoList', param);
}

export function apiSetWarehouseMemo(param) {
	return api.post(prefix + 'setWarehouseMemo', param);
}

export function apiDeleteWarehouseMemoBatch(param) {
	return api.post(prefix + 'deleteWarehouseMemoBatch', param);
}

export function apiSelectInvoicePalletLabel(invoice_no) {
	return api.get(prefix + 'selectInvoicePalletLabel', { params: { invoice_no } });
}

export function apiSaveInvoicePalletLabel(param) {
	return api.post(prefix + 'saveInvoicePalletLabel', param);
}

export function apiSelectReturnBoxList(param) {
	return api.post(prefix + 'selectReturnBoxList', param);
}

export function apiSelectReturnBoxCount(param) {
	return api.post(prefix + 'selectReturnBoxCount', param);
}

export function apiInsertReturnBox(param) {
	return api.post(prefix + 'insertReturnBox', param);
}

export function apiUpdateReturnBox(param) {
	return api.post(prefix + 'updateReturnBox', param);
}

export function apiDeleteReturnBox(param) {
	return api.post(prefix + 'deleteReturnBox', param);
}

export function apiUpdateReturnBoxItemBatch(param) {
	return api.post(prefix + 'updateReturnBoxItemBatch', param);
}

export function apiArrangeReturnBoxOrder(param) {
	return api.post(prefix + 'arrangeReturnBoxOrder', param);
}
